import { createContext } from "react"
import { defaultItemContextValue } from "./defaultItemContextValue"
import type { ItemContextValue } from "./ItemContextValue"

export const ItemContext = createContext<ItemContextValue>(
  defaultItemContextValue,
)
